import { useEffect, useState } from "react";

const SHOP = {
  name: "Bro's Bike Rental Gokarna",
  lat: 14.5479434,
  lng: 74.3176723,
  address: "Fish Market Road, Gokarna",
};

function ShopLocation() {
  const [distance, setDistance] = useState(null);
  const [loading, setLoading] = useState(true);

  // Air distance only (used just for NEAR/FAR decision)
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return Number((R * c).toFixed(1));
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const km = calculateDistance(
          pos.coords.latitude,
          pos.coords.longitude,
          SHOP.lat,
          SHOP.lng
        );
        setDistance(km);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, []);

  const openDirections = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${SHOP.lat},${SHOP.lng}&travelmode=driving`,
      "_blank"
    );
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>📍 Pickup Location</h1>
      <p style={styles.subtitle}>
        Reach our shop easily — navigation opens in Google Maps
      </p>

      <div style={styles.card}>
        <div>
          <h2 style={styles.shopName}>{SHOP.name}</h2>
          <p style={styles.address}>{SHOP.address}</p>

          {!loading && distance !== null && distance <= 50 && (
            <p style={styles.distance}>
              🚴 {distance} km away <span style={styles.note}>(approx)</span>
            </p>
          )}

          {!loading && distance !== null && distance > 50 && (
            <p style={styles.farNote}>
              📍 Location available in Google Maps
            </p>
          )}
        </div>

        <button onClick={openDirections} style={styles.btn}>
          Open in Google Maps
        </button>
      </div>

      {/* MAP */}
      <div style={styles.mapWrap}>
        <iframe
          title="shop-map"
          src={`https://www.google.com/maps?q=${SHOP.lat},${SHOP.lng}&z=15&output=embed`}
          width="100%"
          height="420"
          style={{ border: 0, borderRadius: "16px" }}
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
}

const styles = {
  page: {
    maxWidth: "1000px",
    margin: "auto",
    padding: "100px 20px 32px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
  },
  subtitle: {
    color: "#555",
    marginBottom: "20px",
  },
  card: {
    background: "#ffffff",
    borderRadius: "18px",
    padding: "22px",
    boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },
  shopName: {
    margin: 0,
    fontSize: "22px",
  },
  address: {
    margin: "6px 0",
    color: "#555",
  },
  distance: {
    marginTop: "8px",
    fontWeight: "600",
  },
  farNote: {
    marginTop: "8px",
    fontSize: "14px",
    color: "#666",
  },
  note: {
    fontWeight: "400",
    color: "#777",
    fontSize: "14px",
  },
  btn: {
    background: "#111827",
    color: "#fff",
    padding: "12px 18px",
    borderRadius: "12px",
    border: "none",
    fontSize: "15px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  mapWrap: {
    marginTop: "28px",
  },
};

export default ShopLocation;
